<template lang="pug">
.tlg
  .text-center
    iframe(src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fepicwinphilippines&tabs&width=370&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId' width='370' height='130' style='border:none;overflow:hidden' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share')

  a(:href="getTgLink" target="_blank")
    img(src="/new/img/telegram.png")
</template>
<script>
export default {
  computed:{
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getFbLink(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'facebook'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
    getTgLink(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'telegram'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
  }
}
</script>